The label for the button, e.g. "Apply with SEEK" or "Apply with Jobstreet".
